import React from "react";
import styled from "styled-components";

import {
  Box,
  LazyImage,
  SpanStyled,
  TextStyled,
} from "../../../styled/Elements";
import { MenuTriggerCross, PlaceholderImg } from "../../../styled/AllImages";

const SelectedMultipleUsersList = ({ selectedMainParents, onRemoveClick }) => {  
  const ASSET_URL = process.env.REACT_APP_ASSET_URL;
  const addParents = selectedMainParents?.map((mainParent) => {
    return (
      <MultipleUsersUpload key={mainParent?.id}>
        <Box className="userPlaceholder">
          <LazyImage
            src={
              mainParent?.profile
                ? `${ASSET_URL}/${mainParent?.profile}`
                : PlaceholderImg
            }
            alt="User"
          />
        </Box>
        <Box className="abtUser">
          <TextStyled>
            <SpanStyled color="var(--text)" size="14px">
              {mainParent?.name}
            </SpanStyled>
          </TextStyled>
          {mainParent?.subLabel && (
            <SpanStyled
              color="var(--text2)"
              size="14px"
              family="var(--light)"
              className=""
            >
              {mainParent.subLabel}
            </SpanStyled>
          )}
        </Box>

        <MenuTriggerCross
          className="removeTaskTrigger"
          onClick={() => onRemoveClick(mainParent.id)}
        />
      </MultipleUsersUpload>
    );
  });

  return <>{addParents}</>;
};

export default SelectedMultipleUsersList;

const MultipleUsersUpload = styled.div`
  display: flex;
  gap: 10px;
  align-items: center;
  overflow: hidden;
  position: relative;
  cursor: pointer;
  padding: 8px 16px;
  background-color: var(--bgSecondary);
  border-radius: 10px;
  .userPlaceholder {
    display: flex;
    align-items: center;
    justify-content: center;
    min-width: 30px;
    max-width: 30px;
    height: 30px;
    background-color: var(--greyBg);
    border-radius: 50%;
    // border: 1px dashed var(--greyText);
    overflow: hidden;
    img {
      width: 100%;
      height: 100%;
      object-fit: cover;
    }
  }
  svg.removeTaskTrigger {
    width: 12px;
    height: 12px;
    margin-left: 7px;
    &:hover {
      stroke: var(--redColor);
      fill: var(--redColor);
      path {
        stroke: var(--redColor);
        fill: var(--redColor);
      }
    }
  }
  input[type="file"] {
    opacity: 0;
    position: absolute;
    width: 100%;
    height: 100%;
    cursor: pointer;
  }
  .abtUser {
    display: flex;
    flex-wrap: wrap;
    flex-direction: column;
    span {
      // width: 100%;
    }
  }
`;
